import api from "../../services/api";
import { toast } from "react-toastify";

export async function listTrainees(props) {
  const { query, config } = props;
  try {
    let { data: _trainees } = await api.get(`trainees${query}`, config);
    _trainees.data = _trainees.data?.map(__trainee => formatTrainee(__trainee));
    return _trainees;
  } catch (__error) {
    console.log("__error", __error);
    toast.error("Problemas ao tentar carregar dados dos Formandos.");
  }
}

export async function getTrainee(props) {
  const { id, query, config } = props;
  try {
    let { data: _trainee } = await api.get(`trainees/${id}${query}`, config);
    _trainee = formatTrainee(_trainee, true);
    return _trainee;
  } catch (__error) {
    console.log("__error", __error);
    toast.error("Problemas ao tentar carregar dados do Formando.");
  }
}

export function formatTrainee(__trainee, is_single) {
  let _commercial_label = "";
  if (is_single) {
    const _commercial = __trainee?.commercials;
    const _group_name = !!_commercial?.contract_number_legacy ? ` - ${_commercial?.contract_number_legacy}` : "";
    _commercial_label = `${_commercial?.course?.title} ${_commercial?.institution?.title} ${_commercial?.year}.${_commercial?.period}${_group_name}`;
  } else {
    const _group_name = !!__trainee?.commercials?.contract_number_legacy
      ? ` - ${__trainee?.commercials?.contract_number_legacy}`
      : "";
    _commercial_label = `${__trainee?.courses?.[0]?.title} ${__trainee?.institution?.title} ${__trainee?.commercials?.year}.${__trainee?.commercials?.period}${_group_name}`;
  }
  return {
    ...__trainee,
    access: !__trainee?.active
      ? "Revogado"
      : !__trainee?.approve_by_team
      ? "Aguardando Aprovação"
      : !__trainee?.aceite_virtual
      ? "Aguardando Aceite"
      : !!__trainee?.aceite_virtual
      ? "Autorizado"
      : "?",
    bond: !__trainee?.cancel ? "Ativo" : "Encerrado",
    commercial_label: _commercial_label,
  };
}
